import "../../../css/DesignSystem/Inputs/CheckboxGroup.css";

const normaliseOption = (option) => {
  if (typeof option === "string") {
    return {
      label: option,
      value: option,
    };
  }

  return {
    label: option.label,
    value: option.value,
  };
};

const CheckboxGroup = ({
  options = [],
  selectedOptions = [],
  formDataKey,
  disabled = false,
  error = false,
  handleCheckboxChange,
  onChange,
  columns,
}) => {
  const selectedValues = Array.isArray(selectedOptions) ? selectedOptions : [];

  const toggleValue = (value) => {
    if (disabled) return;

    const isCurrentlyChecked = selectedValues.includes(value);
    const nextChecked = !isCurrentlyChecked;

    const fakeEvent = {
      target: {
        checked: nextChecked,
        value,
        name: formDataKey,
      },
    };

    if (typeof handleCheckboxChange === "function") {
      handleCheckboxChange(fakeEvent, formDataKey, value);
      return;
    }

    if (typeof onChange === "function") {
      const nextValues = nextChecked
        ? Array.from(new Set([...selectedValues, value]))
        : selectedValues.filter((item) => item !== value);

      onChange(nextValues);
    }
  };

  return (
    <div
      className={`ds-checkbox-group ${error ? "ds-checkbox-group--error" : ""}`}
      style={columns ? { "--checkbox-columns": columns } : undefined}
    >
      {options.map((option) => {
        const item = normaliseOption(option);

        const inputId = `${formDataKey}-${String(item.value)
          .replace(/\s+/g, "-")
          .replaceAll("/", "-")
          .toLowerCase()}`;

        const checked = selectedValues.includes(item.value);

        return (
          <label
            key={item.value}
            htmlFor={inputId}
            className="ds-checkbox-card"
            onClick={(e) => {
              e.preventDefault();
              toggleValue(item.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleValue(item.value);
              }
            }}
            tabIndex={disabled ? -1 : 0}
          >
            <input
              id={inputId}
              type="checkbox"
              name={formDataKey}
              value={item.value}
              checked={checked}
              readOnly
              disabled={disabled}
            />

            <span className="ds-checkbox-box" />
            <span className={`FP_Content primary ${checked ? "FP_Content_Semibold" : ""}`}>{item.label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckboxGroup;
